import { ReactNode } from 'react';
import {
  FaLocationDotLightSvgIcon,
  FaLocationPinLightSvgIcon,
} from '../../../assets/icons/svgs';
import { borderRadius } from '../../../theme/borderRadius';
import { colors } from '../../../theme/colors';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';

interface ChooseLocationHeaderProps {
  isApproximateLocation?: boolean;
  title: string;
  description: string | ReactNode;
}

const ChooseLocationHeader = ({
  isApproximateLocation,
  title,
  description,
}: ChooseLocationHeaderProps) => {
  const iconSize = isMobileScreen ? fontSize['6xl'] : fontSize['7xl'];
  const IconComponent = isApproximateLocation
    ? FaLocationDotLightSvgIcon
    : FaLocationPinLightSvgIcon;

  const style = {
    width: isMobileScreen ? 120 : 130,
    height: isMobileScreen ? 120 : 130,
    borderRadius: borderRadius.max,
    backgroundColor: colors.backgroundLight,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `solid 2px ${colors.backgroundSuperLight}`,
    marginBottom: spacing.large,
  };

  return (
    <>
      <div style={style}>
        <IconComponent size={iconSize} style={{ color: colors.textPrimary }} />
      </div>
      <div
        style={{
          marginBottom: spacing.medium,
          fontSize: fontSize.xl,
          color: colors.textPrimary,
          width: '100%',
          textAlign: 'center',
          fontWeight: 'bold',
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: fontSize.md,
          color: colors.textGreyMedium,
          textAlign: 'center',
        }}
      >
        {description}
      </div>
    </>
  );
};

export default ChooseLocationHeader;
